/** @format */

import {ReactNode, useState} from 'react';

import {Unstable_Popup as BasePopup} from '@mui/base/Unstable_Popup';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Box} from '@mui/material';

import PopupBody from './PopupBody';

interface Props {
  title: ReactNode;
  description?: ReactNode;
}

const HeaderCell = ({title, description}: Props) => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  return (
    <Box component='span' sx={{display: 'inline-flex', alignItems: 'center', gap: 1}}>
      {title}
      {description != null && (
        <Box
          component='span'
          sx={{display: 'inline-flex', alignItems: 'center'}}
          onClick={event => event.stopPropagation()}
          onMouseEnter={event => setAnchor(event.currentTarget)}
          onMouseLeave={() => setAnchor(null)}
        >
          <HelpOutlineIcon sx={{fontSize: '16px', color: '#8B8B8B'}} />
          <BasePopup open={Boolean(anchor)} anchor={anchor}>
            <PopupBody>{description}</PopupBody>
          </BasePopup>
        </Box>
      )}
    </Box>
  );
};

export default HeaderCell;
